import React from "react";
import PageLayout from "@layouts/PageLayout";
import { Outlet } from "react-router-dom";
import { useDrybulkCargoOperationsContainer } from "./hooks/useDrybulkCargoOperationsContainer";

/**
 * Dry Bulk Cargo Operations — feature container (DBCO-0007).
 *
 * 🔴 Deliberately contains NO role branch, unlike `BayHireContainer`, which
 * redirects on `isOperationsUser`. Two reasons:
 *
 * 1. HLD § 5.3 scopes the SPA to "rendering, keyboard/AT support" and
 *    explicitly excludes "authorisation decisions". Authorisation is ADR-001's
 *    — a declared policy enforced at the BFF's serialisation choke point and
 *    in the query layer, not a branch in a container.
 * 2. ⚠️ Steering Q-F7 is unresolved: the SPA has TWO notions of "operations
 *    user" that never meet — the realm role `operations` (never sets
 *    `isOperationsUser`, redirects to licenses) and
 *    `roles.includes("terminal") && terminalId in {OPS,DIBOPS}` (the only
 *    setter). `architecture-context.md`:90 describes them as one thing; the
 *    code disagrees. Branching here would silently pick a winner.
 *
 * Route-level access is enforced by `ProtectedRoute` via `requiredPermissions`
 * — see `drybulkCargoOperationsRoutes.tsx`.
 */
const DrybulkCargoOperationsContainer: React.FC = () => {
  const { dir } = useDrybulkCargoOperationsContainer();

  return (
    <PageLayout dir={dir}>
      <Outlet />
    </PageLayout>
  );
};

export default DrybulkCargoOperationsContainer;
